import React from "react";
import { Button, Labeled, ShowProps, TextField } from "react-admin";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRowsWithSpace } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { GetParam } from "utils/tools";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles({
  summaryButton: {
    position: "relative",
    top: 20,
    padding: "8px 16px",
  },
});

const Summary = (props: ShowProps) => {
  const param = GetParam();
  const classes = useStyles();

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Typography variant="h6">Academic Year Detail</Typography>
          <Button
            className={classes.summaryButton}
            onClick={() =>
              props.history.push(
                `/academicYears/${props.id}?schoolId=${param.get("schoolId")}`
              )
            }
            label="Edit"
          >
            <EditIcon />
          </Button>
        </Grid>

        <Grid item xs={4}>
          <Labeled source="Name">
            <TextField source="name" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={3}>
          <Labeled source="Start Date">
            <CustomDateField source="startDate" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="End Date">
            <CustomDateField source="endDate" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Early Registration Start Date">
            <CustomDateField
              source="earlyRegistrationStartDate"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Early Registration End Date">
            <CustomDateField source="earlyRegistrationEndDate" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Late Registration Start Date">
            <CustomDateField source="lateRegistrationStartDate" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={3}>
          <Labeled source="Refund Rate (%)">
            <TextField source="refundRate" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={9}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
